// Program types
export const ADD_MEDAL = "ADD_MEDAL";
export const ZALICZ_ZADANIE = "ZALICZ_ZADANIE";
export const SHOW_MODAL = "SHOW_MODAL";
export const SET_TARCZA = "SET_TARCZA";
export const HIDE_MODAL = "HIDE_MODAL";
export const ADD_ELEMENT = "ADD_ELEMENT";
export const ZAKTUALIZUJ_ELEMENTY = "ZAKTUALIZUJ_ELEMENTY";
export const ZAKUTALIZUJ_ROZWIAZANIE = "ZAKUTALIZUJ_ROZWIAZANIE";
